import { Box, Chip } from "@mui/material";
import React, { useMemo, useState } from "react";
import NoRecordsFound from "../../../components/no-records-found";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";

import { Popover, Button } from "antd";
import { FiMoreVertical, FiLock, FiCheckCircle } from "react-icons/fi";

const ReportsTable = ({ tab, reportsData, onResolve, onBlock }) => {
  const [activePopoverId, setActivePopoverId] = useState(null);

  const handleClosePopover = () => {
    setActivePopoverId(null);
  };

  const columns = useMemo(() => {
    switch (tab) {
      case "TEACHER":
        return [
          {
            field: "createdAt",
            headerName: "Date",
            flex: 1,
            minWidth: 110,
            valueGetter: (row) => moment(row).format("MMM Do YY"),
          },
          {
            field: "title",
            headerName: "Title",
            flex: 1,
            minWidth: 110,
          },
          {
            field: "content",
            headerName: "Description",
            flex: 1,
            minWidth: 110,
            renderCell: ({ value }) => {
              const isLong = value?.length > 35;
              const truncated = isLong ? `${value.slice(0, 35)}...` : value;
              return isLong ? (
                <Popover content={value} trigger="hover">
                  <span>{truncated}</span>
                </Popover>
              ) : (
                <span>{value}</span>
              );
            },
          },
          {
            field: "student",
            headerName: "Student Name",
            flex: 1,
            minWidth: 110,
            renderCell: (params) => params?.row?.student?.fullName || "",
          },
          {
            field: "teacher",
            headerName: "Report by",
            flex: 1,
            minWidth: 110,
            renderCell: (params) => params?.row?.teacher?.fullName || "",
          },
          {
            field: "isBlocked",
            headerName: "Status",
            flex: 1,
            minWidth: 110,
            renderCell: ({ row }) => (
              <Chip
                label={row?.student?.isBlocked ? "Blocked" : "Active"}
                color={row?.student?.isBlocked ? "error" : "success"}
                size="small"
              />
            ),
          },
          {
            field: "actions",
            headerName: "",
            flex: 0.5,
            minWidth: 50,
            sortable: false,
            renderCell: (param) => {
              const isOpen = activePopoverId === param.row.id;

              const handleResolve = () => {
                handleClosePopover();
                onResolve?.(
                  param?.row?.student?.id,
                  param?.row?.id,
                  !param?.row?.isResolved //vise verca . if true then false
                );
              };

              const handleBlock = () => {
                handleClosePopover();
                onBlock(
                  param?.row?.student?.id,
                  param?.row?.student?.isBlocked
                );
              };

              return (
                <Popover
                  open={isOpen}
                  onOpenChange={(visible) =>
                    setActivePopoverId(visible ? param.row.id : null)
                  }
                  content={
                    <ActionPopover
                      onResolve={handleResolve}
                      onBlock={handleBlock}
                      isBlocked={param?.row?.student?.isBlocked}
                    />
                  }
                  trigger="click"
                  placement="bottomRight"
                >
                  <Button type="text" icon={<FiMoreVertical />} />
                </Popover>
              );
            },
          },
        ];
      case "STUDENT":
        return [
          {
            field: "createdAt",
            headerName: "Date",
            flex: 1,
            minWidth: 110,
            valueGetter: (row) => moment(row).format("MMM Do YY"),
          },
          {
            field: "title",
            headerName: "Title",
            flex: 1,
            minWidth: 110,
          },
          {
            field: "content",
            headerName: "Description",
            flex: 1,
            minWidth: 110,
            renderCell: ({ value }) => {
              const isLong = value?.length > 35;
              const truncated = isLong ? `${value.slice(0, 35)}...` : value;
              return isLong ? (
                <Popover content={value} trigger="hover">
                  <span>{truncated}</span>
                </Popover>
              ) : (
                <span>{value}</span>
              );
            },
          },
          {
            field: "teacher",
            headerName: "Teacher",
            flex: 1,
            minWidth: 110,
            renderCell: (params) => params?.row?.teacher?.fullName || "",
          },
          {
            field: "student",
            headerName: "Report by",
            flex: 1,
            minWidth: 110,
            renderCell: (params) => params?.row?.student?.fullName || "",
          },
          {
            field: "isBlocked",
            headerName: "Status",
            flex: 1,
            minWidth: 110,
            renderCell: ({ row }) => (
              <Chip
                label={row?.teacher?.isBlocked ? "Block" : "Active"}
                color={row?.teacher?.isBlocked ? "error" : "success"}
                size="small"
              />
            ),
          },
          {
            field: "actions",
            headerName: "Actions",
            flex: 0.5,
            minWidth: 50,
            sortable: false,
            renderCell: (param) => {
              const isOpen = activePopoverId === param.row.id;

              const handleResolve = () => {
                handleClosePopover();
                onResolve?.(
                  param?.row?.teacher?.id,
                  param?.row?.id,
                  !param?.row?.isResolved //vise verca . if true then false
                );
              };
              const handleBlock = () => {
                handleClosePopover();
                onBlock(
                  param?.row?.teacher?.id,
                  param?.row?.teacher?.isBlocked
                );
              };

              return (
                <Popover
                  open={isOpen}
                  onOpenChange={(visible) =>
                    setActivePopoverId(visible ? param.row.id : null)
                  }
                  content={
                    <ActionPopover
                      onResolve={handleResolve}
                      onBlock={handleBlock}
                      isBlocked={param?.row?.teacher?.isBlocked}
                    />
                  }
                  trigger="click"
                  placement="bottomRight"
                >
                  <Button type="text" icon={<FiMoreVertical />} />
                </Popover>
              );
            },
          },
        ];
      default:
        return [];
    }
  }, [tab, activePopoverId, onResolve, onBlock]);

  return reportsData.length > 0 ? (
    <Box
      sx={{
        height: 400,
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <DataGrid
        rows={reportsData}
        columns={columns}
        getRowId={(row) => row?.id}
        sx={{
          fontSize: "16px",
          flex: 1,
          width: "100%",
          "& .MuiDataGrid-root": {
            overflow: "auto",
          },
          "& .MuiDataGrid-virtualScroller": {
            overflow: "auto !important",
          },
        }}
        hideFooter
        hideFooterPagination
      />
    </Box>
  ) : (
    <Box sx={{ textAlign: "center", mt: 4 }}>
      <NoRecordsFound />
    </Box>
  );
};

const ActionPopover = ({ onBlock, onResolve, isBlocked }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
    <Button
      type="text"
      icon={<FiLock />}
      style={{ textAlign: "left" }}
      onClick={onBlock}
    >
      {isBlocked ? "Unblock" : "Block"}
    </Button>
    <Button
      type="text"
      icon={<FiCheckCircle />}
      style={{ textAlign: "left" }}
      onClick={onResolve}
    >
      Resolved
    </Button>
  </div>
);

export default ReportsTable;
